let AUTHORIZED;

export function isAuthorized() {
    return AUTHORIZED;
}

export function setIsAuthorized(v) {
    AUTHORIZED = v;
}
